import $confirm from '@/pages/user-execption/components/module';
import { toast } from '@/utils/toast';

export const showExpModal = (code:number, data:any, fn?:any) => {
  if (data.code === code) {
    const reason = data.data[0];
    if (reason) {
      if (reason.type === 1) {
        localStorage.setItem('frozenReasons', JSON.stringify(reason));
      }
      const title = reason.text || '';
      if (reason.frozenReasons[0]) {
        const firstReason = reason.frozenReasons[0];
        const showResult = $confirm.userExp({
          title: title,
          sub: firstReason.text
        });
        // 防止 弹框与toast 同时出现
        if (showResult) { // 有弹出框时 暂时取消 toast
          const errorToast = toast.error;
          toast.error = () => {
            toast.error = errorToast;
            return { close: () => '' };
          };
          setTimeout(() => {
            toast.error = errorToast;
          }, 0);
        }
      }
    }
  } else {
    fn && fn();
  }
};
export const removeLocalExp = () => {
  localStorage.removeItem('frozenReasons');
};
export const checkUserExp = (res:any) => {
  const userExpCode = res.data && res.data.code;
  if ([31021, 36003, 32128, 30071].includes(userExpCode)) {
    showExpModal(userExpCode, res.data);
  }
};

export default {
  showExpModal,
  removeLocalExp,
  checkUserExp
};
